import { memo } from 'react';

import Skeleton from '@mui/material/Skeleton';

export const LabelLoader = memo(() => {
  return <Skeleton height={60} variant="text" width={200} />;
});
